import {ExplorerContentTypes, UserRoleLevel} from 'constants/dataEnum';
import {parseMessage} from 'lib/stringHelper';
import {
  getCurrentProtocolFolder,
  getRunningProtocol,
  getSelectedProtocolAndFolderIds,
} from 'stores/selectors/protocolExplorerSelectors';
import {protocolExplorerHelper} from 'lib/explorerHelper';
import {selectSessionUserId} from 'stores/selectors/sessionSelectors';
import {ProtocolExplorerAccordionGroup} from 'constants/protocolExplorerEnum';
import {setCurrentProtocolFolder} from 'stores/actions/protocolExplorerAction';
import {protocolExplorerBusiness, protocolMenuHandler} from '../protocolExplorerBusiness';
import {isRoleLevel} from '../userManagementBusiness';

export const getSelectedProtocolsCondition = () => (dispatch, getState) => {
  const selectedItemIds = getSelectedProtocolAndFolderIds(getState());
  const userId = selectSessionUserId(getState());
  const selectedItems = dispatch(protocolExplorerBusiness.getSelectedItems(selectedItemIds));

  const runningProtocol = getRunningProtocol(getState());
  const runningFolderIds = runningProtocol?.protocolFolderLineages?.map((e) => e.id) || Array(0);

  const isSelectingNothing = !selectedItems.length;
  const isContainingTessaraProtocol = protocolExplorerHelper.isContainingTessaraProtocol(selectedItems);
  const isContainingSharedItems = !protocolExplorerHelper.isOwnedEveryItems(selectedItems, userId);
  const isContainingFolder = selectedItems.find((item) => item.type === ExplorerContentTypes.FOLDER);
  const isContainingFavoriteGroupItem = selectedItems.find(
    (item) => item.groupView === ProtocolExplorerAccordionGroup.FAVORITE_PROTOCOLS,
  );

  const isSelectedProtocolCurrentlyBeingExecuted = selectedItems.find(
    (item) => item[item.type].id === runningProtocol?.id,
  );
  const isSelectedFolderCurrentlyBeingExecuted = runningFolderIds.some((e) => selectedItemIds.includes(e));
  const isContainingCurrentlyExecutingItem =
    isSelectedProtocolCurrentlyBeingExecuted || isSelectedFolderCurrentlyBeingExecuted;

  const isSelectingMixedRegularTessaraProtocol =
    isContainingTessaraProtocol && selectedItems.find((item) => !item[item.type].isTessaraProtocol);

  return {
    selectedItemIds,
    selectedItems,
    isSelectingNothing,
    isContainingTessaraProtocol,
    isContainingSharedItems,
    isContainingFolder,
    isContainingCurrentlyExecutingItem,
    isContainingFavoriteGroupItem,
    isSelectingMixedRegularTessaraProtocol,
  };
};

export const createDuplicateMenu = (selectedItemsCondition) => (dispatch) => {
  const isTessaraSuperUser = dispatch(isRoleLevel(UserRoleLevel.TESSARA_SUPER_USER));
  const {selectedItems, isSelectingNothing, isContainingTessaraProtocol} = selectedItemsCondition;

  const label = parseMessage('explorer.explorerHeader.menuMore.duplicateOption');
  const icon = 'Duplicate';
  const disabled = isSelectingNothing || (isContainingTessaraProtocol && !isTessaraSuperUser);
  const onClick = () => dispatch(protocolMenuHandler.handleDuplicateProtocol(selectedItems));

  return {label, icon, onClick, disabled};
};

export const createFavoriteMenu = (selectedItemsCondition) => (dispatch) => {
  let isUnfavorite;

  const {selectedItems, isSelectingNothing, isContainingFolder} = selectedItemsCondition;

  if (isContainingFolder || isSelectingNothing) {
    return null;
  }

  const isSelectionMixed = selectedItems.find((protocol) => {
    const isFavoriteStatusChanged = isUnfavorite !== undefined && isUnfavorite !== protocol.isFavorite;
    // if already in favorite, set the favorite operation as to un-favorite
    isUnfavorite = protocol.isFavorite;

    return isFavoriteStatusChanged;
  });

  const setToFavoriteLabel = parseMessage('explorer.explorerHeader.menuMore.addToFavorite');
  const removeFromFavoriteLabel = parseMessage('explorer.explorerHeader.menuMore.removeFromFavorite');

  const setToFavoriteIcon = 'StartFilled';
  const removeFromFavoriteIcon = 'StarOff';

  const label = isUnfavorite ? removeFromFavoriteLabel : setToFavoriteLabel;
  const icon = isUnfavorite ? removeFromFavoriteIcon : setToFavoriteIcon;
  const disabled = isSelectionMixed || isSelectingNothing || isContainingFolder;
  const onClick = () => dispatch(protocolMenuHandler.handleFavoriteClick(selectedItems, !isUnfavorite));

  return {label, icon, onClick, disabled};
};

export const createOpenProtocolLocationMenu = (selectedItemsCondition) => (dispatch, getState) => {
  const currentFolder = getCurrentProtocolFolder(getState());
  const {selectedItems, isSelectingNothing} = selectedItemsCondition;

  const isMultiSelection = selectedItems?.length > 1;
  const selectedItem = selectedItems[0];
  const {protocolFolderLineages} = selectedItem?.protocol || {};
  const isOnFavoriteProtocolsGroup = selectedItem?.groupView === ProtocolExplorerAccordionGroup.FAVORITE_PROTOCOLS;

  let protocolLocation = '';
  let isOnSameFolder = true;

  if (protocolFolderLineages && protocolFolderLineages.length) {
    protocolLocation = protocolFolderLineages[protocolFolderLineages.length - 1];
    isOnSameFolder = currentFolder?.id === protocolLocation.id;
  }

  if (!isOnFavoriteProtocolsGroup) {
    return null;
  }

  const label = parseMessage('explorer.explorerHeader.menuMore.openProtocolLocation');
  const icon = 'MoveTo';
  const disabled = isSelectingNothing || isMultiSelection || isOnSameFolder;
  const onClick = () => dispatch(setCurrentProtocolFolder(protocolLocation));

  return {label, icon, onClick, disabled};
};
